// import { url } from '@/views/visual/dataScreen/js/config';
// import request from '@/views/visual/dataScreen/js/axios'
import { axios } from '@/utils/request';
export var getList = function getList(params) {
  return axios({
    url: '/visual/map/list',
    method: 'get',
    params: params
  });
};
export var getObj = function getObj(id) {
  return axios({
    url: '/visual/map/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var addObj = function addObj(data) {
  return axios({
    url: '/visual/map/save',
    method: 'post',
    data: data
  });
};
export var updateObj = function updateObj(data) {
  return axios({
    url: '/visual/map/update',
    method: 'post',
    data: data
  });
};
export var delObj = function delObj(id) {
  return axios({
    url: '/visual/map/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};